import { useQuery } from '@tanstack/react-query';
import { api } from 'src/api/api-client.config';
import { ContestType } from 'src/types/domain.types';  

const getContests = (): Promise<{ contests: ContestType[] }> =>
  api.get(`/contests`);

export const useGetContestsQuery = () => {
  return useQuery({
    queryKey: ['contests'],
    queryFn: getContests,
    select: (data) => data.contests,
  });
};
